module.exports = __webpack_public_path__ + "static/media/postcard2.dcc5f354.jpg";